import styled from 'styled-components';

export const AccountSelectWrapper = styled.div`

`;
